import DialogActions from "@mui/material/DialogActions";
import ModalBasicLayout from "../Modal/ModalBasicLayout";
import Button from "../Buttons/Button";
import { useTranslationApp } from "../../lib/i18next";
import { OK, READY } from "../../i18n/keysTranslations";
import ApprovalEnableSuccessContent from "./ApprovalEnableSuccessContent";

const ApprovalEnableSuccessDialog = ({
  modalOpen = false,
  onCloseModal = () => {},
  approvalType = "content",
  approvalUrl = "",
  approvalID = "",
  reviewerID = "",
  defaultEmail = "",
}) => {
  const { t } = useTranslationApp();

  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      title=""
      titleContent={false}
      hasTitle={false}
      maxWidth="sm"
      fullWidth
      enableHistoryManagement={false}
      ariaLabel={t(READY)}
      zIndex={1700}
      sxContent={{
        pt: 7,
        px: { xs: 2.5, sm: 3 },
        pb: 1,
        maxHeight: "min(520px, 70vh)",
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <ApprovalEnableSuccessContent
        approvalType={approvalType}
        approvalUrl={approvalUrl}
        approvalID={approvalID}
        reviewerID={reviewerID}
        defaultEmail={defaultEmail}
      />

      <DialogActions sx={{ justifyContent: "center", px: 3, pb: 3, pt: 2 }}>
        <Button type="button" onClick={onCloseModal} sx={{ minWidth: 150 }}>
          {t(OK)}
        </Button>
      </DialogActions>
    </ModalBasicLayout>
  );
};

export default ApprovalEnableSuccessDialog;
